import {ApiCisternResponseDto} from '@birco/rainmesh-api';
import {ApiFilters} from '../../../core/models/interfaces/api-filters.interface';

export const FEATURE_NAME = 'cisternState';

export interface CisternState {
  entities: Record<string, ApiCisternResponseDto>; // Cache for the actual device objects
  error: any | null;
  isLoading: boolean;
  filter: CisternFilter;
  pages: Record<number, string[]>; // Page number to ruleIds on that page
  totalCount: number;
}

export interface CisternFilter extends ApiFilters {}

export const initialState: CisternState = {
  entities: {},
  filter: {
    page: 0,
    pageSize: 6,
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
}
